import SizeModal from './SizeModal';

export default SizeModal;
